export default __webpack_public_path__ + "static/media/a021-viewmore-fsi.40275f2c.jpg";